import { render, staticRenderFns } from "./Law.vue?vue&type=template&id=5d05f5b6&scoped=true"
import script from "./Law.vue?vue&type=script&lang=js"
export * from "./Law.vue?vue&type=script&lang=js"
import style0 from "./Law.vue?vue&type=style&index=0&id=5d05f5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05f5b6",
  null
  
)

export default component.exports